module.exports = __webpack_public_path__ + "static/orthodontics03-c718700ca8a1b2d5a9279bf7ae986ee1.jpg";